// src/pages/taxonomy/Categories/CategoriesFormPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { CategoriesAPI } from '../../../api/v3/taxonomy-api-v3';

const BASE = '/app/sales/bagspa/taxonomy';

function unwrapItem(payload) {
  if (!payload) return {};
  if (payload.item) return payload.item;
  if (payload.data && !Array.isArray(payload.data)) return payload.data;
  return payload;
}

export default function CategoriesFormPage() {
  const { id } = useParams();
  const history = useHistory();
  const isEdit = Boolean(id);

  const [name, setName]   = useState('');
  const [code, setCode]   = useState(''); // new
  const [active, setActive] = useState(true); // optional
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  useEffect(() => {
    async function load() {
      if (!isEdit) return;
      try {
        setLoading(true);
        const payload = await CategoriesAPI.show(id);
        const item = unwrapItem(payload) || {};
        setName(item.name || '');
        setCode(item.code || '');
        setActive(item.active !== false); // default true if missing
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [id, isEdit]);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);

      // normalize code => uppercase, trim
      const codeClean = (code || '').trim().toUpperCase();

      const payload = { name, code: codeClean, active };
      if (isEdit) {
        await CategoriesAPI.update(id, payload);
      } else {
        await CategoriesAPI.create(payload);
      }
      history.push(`${BASE}/categories`);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">{isEdit ? 'Edit' : 'New'} Category</h3>
        <Link to={`${BASE}/categories`}>&larr; Back</Link>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Category name</label>
          <input
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Unique name"
            required
          />
        </div>

        <div className="form-group">
          <label>Code (2 letters)</label>
          <input
            className="form-control"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
            placeholder="e.g. BG"
            maxLength={2}
          />
          <small className="form-text text-muted">
            Used for SKU generation (e.g., BGS-<b>BG</b>-01110).
          </small>
        </div>

        <div className="form-check mb-3">
          <input
            id="cat-active"
            type="checkbox"
            className="form-check-input"
            checked={!!active}
            onChange={e => setActive(e.target.checked)}
          />
          <label htmlFor="cat-active" className="form-check-label">Active</label>
        </div>

        <button className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving…' : 'Save'}
        </button>
      </form>
    </div>
  );
}
